import { PropertyValue } from "./PropertyValue";

export class ImagePropertyValue extends PropertyValue {
	public ImageId: number;
	public Thumbnail: string;
}